import React, { useEffect } from "react";
import "./ProfileModal.css";

function ProfileModal({ profile, type, onClose }) {
  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  if (!profile) return null;
  const name = `${profile.name} ${profile.surname}`;
  const role = profile.profileTitle || (type === "coach" ? "Coach" : "Athlete");
  const highlights = profile.achievements || [];

  return (
    <div className="profile-modal" role="dialog" aria-modal="true" aria-label={`${name} profile`}>
      <button className="profile-modal__backdrop" type="button" onClick={onClose} aria-label="Close profile" />
      <article className="profile-modal__content">
        <button className="profile-modal__close" type="button" onClick={onClose} aria-label="Close profile">×</button>
        <img className="profile-modal__image" src={profile.imageUrl} alt={name} />
        <div className="profile-modal__body">
          <p className="profile-modal__role">{role}</p>
          <h3>{name}</h3>
          {profile.biography && <p>{profile.biography}</p>}
          {highlights.length > 0 && <div className="profile-modal__highlights">
            <p>Profile highlights</p>
            <ul>{highlights.map((highlight) => <li key={highlight}>{highlight}</li>)}</ul>
          </div>}
        </div>
      </article>
    </div>
  );
}

export default ProfileModal;